<template>
    <div class="petcentlist" :style="{display:percentisshow}">
        <div class="petcentlist-in">
            <div class="petcentborder"><div class="percent" :style="{width:percentwidth}" /></div>
            <div class="percenttitle">{{option.title}}</div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['width','isshow','option'],
  data() {
      return {
          percentisshow: this.isshow ? 'inline-flex !important' : 'none !important',
          percentwidth: this.width ? this.width : '0%',
          option: {
              title:this.option && this.option.title ? this.option.title : '操作正在进行中，请等待...',
          },
      }
  },

  watch: {
      isshow(val) {
          this.percentisshow=val ? 'inline-flex !important' : 'none !important';
      },
      width(val) {
          this.percentwidth=val;
      },
  },

  mounted() {
      
  },

  methods: {

  }

}
</script>

<style scoped>
.petcentlist {position:fixed;width:100%;height:100%;top:0;left:0;z-index:100;background-color:rgba(0,0,0,.9);display:inline-flex !important;justify-content:center !important;align-items:center !important}
.petcentlist-in {width:300px;}
.petcentborder {display:inline-block;width:100%;border-radius:20px;border:3px solid #666eeb;padding:3px;display:inline-flex;justify-content:left;align-items:center;}
.percent {display:inline-block;width:0%;height:10px;border-radius:20px;background-color:#666eeb;transition:.3s width !important;}
.percenttitle {display:inline-block;width:100%;margin-top:20px;text-align:center;color:#ffffff;letter-spacing:2px;font-size:12px;}
</style>